
import { Vue, Component, Watch, Prop, Model, Ref } from 'vue-property-decorator';
import { v4 } from 'uuid';
import { component as Viewer } from 'v-viewer';
import VideoUModal from '@/components/video/VideoModal.vue';

@Component({
  components: {
    Viewer,
    VideoUModal,
  },
})
export default class AlbumImageField extends Vue {
  val: any = '';

  @Prop()
  readonly!: boolean;

  @Prop()
  disabled!: boolean;

  uuid = v4;

  @Ref('videoUModal')
  videoUModal!: VideoUModal;

  @Model('change')
  value!: any;

  dictionaryObject: any = {
    env: '环境',
    product_service: '产品服务',
    other: '其他',
    inner_env: '店内环境',
    video: '视频',
    header: '头图',
    shops: '适用门店',
    template_name: '模版名称',
    cover: '封面图',
    new: '新模版名称',
    old: '原模版名称',
    add: '本次新增',
    delete: '本次删除',
  };

  @Watch('value')
  watchValue() {
    console.log(this.value);
    if (this.value) {
      this.val = this.value;
    } else {
      this.val = '';
    }
  }

  extractAddDelete(obj: Record<string, any>): { add?: any[]; delete?: any[] } {
    const add = Array.isArray(obj.add) ? obj.add : [];

    const del = Array.isArray(obj.delete) ? obj.delete : [];

    const result: any = { add, delete: del };

    if (add.length === 0) {
      delete result.add;
    }

    if (del.length === 0) {
      delete result.delete;
    }

    return result;
  }

  removeEmptyHeader<T extends Record<string, any>>(obj: T): Omit<T, 'header'> | T {
    const { header, ...rest } = obj;

    if (Array.isArray(header) && header.length === 0) {
      return rest as Omit<T, 'header'>;
    }

    return obj;
  }

  mounted() {
    this.watchValue();
  }

  playVideo(res: any) {
    this.videoUModal.open(res.path);
  }
}
